import React from 'react';
import { useIsAccountActivationRequired } from 'hooks';
import useTranslate from 'lib/languages/useTranslate';

const ActivateCardBanner = () => {
    const isAccountActivationRequired = useIsAccountActivationRequired();
    const translate = useTranslate('activateCardBanner');

    if (!isAccountActivationRequired) return null;

    return (
        <div className="activation-banner-container">
            <p className="activation-banner-text">{translate('webMessage')}</p>
        </div>
    );
};

export default ActivateCardBanner;
